import type { StoreBundleOption } from "../types"

export const isConfiguredSinglePurchaseOption = (option: StoreBundleOption) =>
  option.quantity === 1 &&
  option.quantity_mode === "exact" &&
  option.composition_mode === "fixed" &&
  option.product_pool_mode === "inherit" &&
  option.pricing_mode === "current" &&
  (option.products?.length ?? 0) === 0 &&
  (option.variants?.length ?? 0) === 0
